
// import './App.css';
// import './assets/css/style.css';
// import './assets/css/modal.css';
// import './assets/fonts/stylesheet.css';
// import './assets/css/custom.css';
// import 'swiper/css';
// import Home from './pages/Home';
// import Project_index from './pages/Project_index';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import React, { useEffect, useState } from 'react';
// import ContactUS from './pages/ContactUs';
// import Projects from './pages/Projects';

// import ProtectedRoute from './components/admincomponents/ProtectedRoutes';
// import Dashboard from './pages/admin/Dashboard';
// import Settings from './pages/admin/Settings';
// import AdminLogin from './components/admincomponents/AdminLogin';

// // projects
// import AddProjects from './pages/admin/AddProject';
// import UpdateProjects from './pages/admin/UpdateProject';
// import AdminProjects from './pages/admin/AdminProjects';
// import ViewProjects from './pages/admin/ViewProject';

// // portfolios
// import AddPortfolio from './pages/admin/AddPortfolio';
// import UpdatePortfolio from './pages/admin/UpdatePortfolio';
// import AdminPortfolios from './pages/admin/AdminPortfolios';
// import ViewPortfolio from './pages/admin/ViewPortfolio';

// // shareholders
// import AddShareholder from './pages/admin/AddShareholder';
// import UpdateShareholder from './pages/admin/UpdateShareholder';
// import AdminShareholders from './pages/admin/AdminShareholders';
// import ViewShareholder from './pages/admin/ViewShareholder';

// // Reviews
// import AddReviews from './pages/admin/AddReviews';
// import AdminReviews from './pages/admin/AdminReviews';
// import ViewReview from './pages/admin/ViewReview';
// import UpdateReview from './pages/admin/UpdateReview';
// // blogs
// import Addblog from './pages/admin/Addblog';
// import UpdateBlog from './pages/admin/UpdateBlog';
// import AdminBlogs from './pages/admin/AdminBlogs';
// import ViewBlog from './pages/admin/ViewBlog';

// // blogs
// import AddTeam from './pages/admin/AddTeam';
// import UpdateTeam from './pages/admin/UpdateTeam';
// import TeamsList from './pages/admin/TeamsList';
// import ViewTeam from './pages/admin/ViewTeam';

// import { PrimeReactProvider } from 'primereact/api';
// import "primereact/resources/themes/lara-light-cyan/theme.css";
// import ShareholderTemplate from './pages/ShareholderTemplate';
// import Blog from './pages/Blog';
// import BlogIndex from './pages/BlogIndex';

// import Categorys from './pages/admin/CategoryListPage';
// import ViewCategory from './pages/admin/CategoryDetailsPage';
// import UpdateCategory from './pages/admin/CategoryUpdatePage';
// import AddCategory from './pages/admin/CategoryAddPage';
// // Aos Animation

// import "aos/dist/aos.css";
// import About from './pages/About';
// import ForContractors from './pages/ForContractors';
// import ForArchitectsDesigners from './pages/ForArchitectsDesigners';
// import LightingFacade from './pages/LightingFacade';
// import AdminProjectsFeatured from './pages/admin/AdminProjectsFeatured';
// import PrivacyPolicy from './pages/PrivacyPolicy';
// import TermsOfUse from './pages/TermsOfUse';
// import AdminLanguage from './pages/admin/AdminLanguage';
// import AddLanguage from './pages/admin/AddLanguage';
// import ViewLanguage from './pages/admin/ViewLanguage';
// import UpdateLanguage from './pages/admin/UpdateLanguage';
// import LanguageRoute from './components/LanguageRoute';
// import HomePageBannerData from './pages/admin/HomePageBannerData';
// import FacadePageBannerData from './pages/admin/FacadePageBannerData';


// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const isAdminRoute = window.location.pathname.startsWith('/admin');

//   useEffect(() => {
//     const body = document.querySelector("body");
//     if (isAdminRoute) {
//       body.classList.add("adminPanel");
//     } else {
//       body.classList.remove("adminPanel");
//     }

//     const token = localStorage.getItem('token');
//     if (token) {
//       setIsAuthenticated(true);
//     }
//     setIsLoading(false);
//   }, []);

//   const handleLogin = () => {
//     setIsAuthenticated(true);
//   };

//   const handleLogout = () => {
//     setIsAuthenticated(false);
//     localStorage.removeItem('token');
//   };

//   if (isLoading) {
//     // Render nothing or a loading spinner until authentication is confirmed
//     return <div>Loading...</div>;
//   }

//   return (
//     <>
//       <PrimeReactProvider>
//         <Routes>

//           <Route path="/" element={<Home />} />
//           <Route path="/project_index" element={<Project_index />} />
//           <Route path="/contact-us" element={<ContactUS />} />
//           <Route path="/project/:id" element={<Projects />} />
//           <Route path="/shareholders" element={<ShareholderTemplate />} />
//           <Route path="/blogs" element={<Blog />} />
//           <Route path="/blog-index/:slug" element={<BlogIndex />} />
//           <Route path="/about" element={<About />} />
//           <Route path="/for-contractors" element={<ForContractors />} />
//           <Route path="/for-architects-and-designers" element={<ForArchitectsDesigners />} />
//           <Route path="/lighting-facade" element={<LightingFacade />} />
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//           <Route path="/terms-of-use" element={<TermsOfUse />} />






//           <Route path="/:lang/" element={<LanguageRoute><Home /></LanguageRoute>} />
//           <Route path="/:lang/project_index" element={<LanguageRoute><Project_index /></LanguageRoute>} />
//           <Route path="/:lang/contact-us" element={<LanguageRoute><ContactUS /></LanguageRoute>} />
//           <Route path="/:lang/project/:id" element={<LanguageRoute><Projects /></LanguageRoute>} />
//           <Route path="/:lang/shareholders" element={<LanguageRoute><ShareholderTemplate /></LanguageRoute>} />
//           <Route path="/:lang/blogs" element={<LanguageRoute><Blog /></LanguageRoute>} />
//           <Route path="/:lang/blog-index/:slug" element={<LanguageRoute><BlogIndex /></LanguageRoute>} />
//           <Route path="/:lang/about" element={<LanguageRoute><About /></LanguageRoute>} />
//           <Route path="/:lang/for-contractors" element={<LanguageRoute><ForContractors /></LanguageRoute>} />
//           <Route path="/:lang/for-architects-and-designers" element={<LanguageRoute><ForArchitectsDesigners /></LanguageRoute>} />
//           <Route path="/:lang/lighting-facade" element={<LanguageRoute><LightingFacade /></LanguageRoute>} />
//           <Route path="/:lang/privacy-policy" element={<LanguageRoute><PrivacyPolicy /></LanguageRoute>} />
//           <Route path="/:lang/terms-of-use" element={<LanguageRoute><TermsOfUse /></LanguageRoute>} />











//           {/* frontend routes */}
//           <Route
//             path="/admin/dashboard"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <Dashboard onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/login"
//             element={
//               isAuthenticated ? (
//                 <Navigate to="/admin/dashboard" />
//               ) : (
//                 <AdminLogin onLogin={handleLogin} />
//               )
//             }
//           />

//           {/* Projects */}
//           <Route
//             path="/admin/projects"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AdminProjects onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/fetured-projects"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AdminProjectsFeatured onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/add-project"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AddProjects onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/project/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <ViewProjects onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/update-project/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <UpdateProjects onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           {/* Language */}
//           <Route
//             path="/admin/languages"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AdminLanguage onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/add-language"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AddLanguage onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/language/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <ViewLanguage onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/update-language/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <UpdateLanguage onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/category"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <Categorys onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/category-details/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <ViewCategory onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/category-update/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <UpdateCategory onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/category-add"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AddCategory onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/home-page-banner"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <HomePageBannerData onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//             <Route
//             path="/admin/facade-page"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <FacadePageBannerData onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           {/* Portfolios */}
//           <Route
//             path="/admin/portfolios"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AdminPortfolios onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/add-portfolio"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AddPortfolio onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/portfolio/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <ViewPortfolio onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/update-portfolio/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <UpdatePortfolio onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           {/* Shareholders */}
//           <Route
//             path="/admin/shareholders"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AdminShareholders onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/add-shareholder"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AddShareholder onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/shareholder/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <ViewShareholder onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/update-shareholder/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <UpdateShareholder onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           {/* Reviews */}
//           <Route
//             path="/admin/add-review"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AddReviews onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/reviews"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AdminReviews onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/review/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <ViewReview onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/update-review/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <UpdateReview onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           {/* Blogs */}
//           <Route
//             path="/admin/blogs"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AdminBlogs onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/add-blog"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <Addblog onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/blog/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <ViewBlog onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/update-blog/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <UpdateBlog onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           {/* Teams */}
//           <Route
//             path="/admin/teams"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <TeamsList onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/add-team"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <AddTeam onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/team/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <ViewTeam onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/update-team/:id"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <UpdateTeam onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/admin/settings"
//             element={
//               <ProtectedRoute isAuthenticated={isAuthenticated}>
//                 <Settings onLogout={handleLogout} />
//               </ProtectedRoute>
//             }
//           />

//         </Routes>
//       </PrimeReactProvider>
//     </>
//   );
// }

// export default App;



import './App.css';
import './assets/css/style.css';
import './assets/css/modal.css';
import './assets/fonts/stylesheet.css';
import './assets/css/custom.css';
import 'swiper/css';
import { Suspense, lazy } from "react";
// import Home from './pages/Home';
// import Project_index from './pages/Project_index';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
// import ContactUS from './pages/ContactUs';
// import Projects from './pages/Projects';

import ProtectedRoute from './components/admincomponents/ProtectedRoutes';
import Dashboard from './pages/admin/Dashboard';
import Settings from './pages/admin/Settings';
import AdminLogin from './components/admincomponents/AdminLogin';

// projects
import AddProjects from './pages/admin/AddProject';
import UpdateProjects from './pages/admin/UpdateProject';
import AdminProjects from './pages/admin/AdminProjects';
import ViewProjects from './pages/admin/ViewProject';

// portfolios
import AddPortfolio from './pages/admin/AddPortfolio';
import UpdatePortfolio from './pages/admin/UpdatePortfolio';
import AdminPortfolios from './pages/admin/AdminPortfolios';
import ViewPortfolio from './pages/admin/ViewPortfolio';

// shareholders
import AddShareholder from './pages/admin/AddShareholder';
import UpdateShareholder from './pages/admin/UpdateShareholder';
import AdminShareholders from './pages/admin/AdminShareholders';
import ViewShareholder from './pages/admin/ViewShareholder';

// Reviews
import AddReviews from './pages/admin/AddReviews';
import AdminReviews from './pages/admin/AdminReviews';
import ViewReview from './pages/admin/ViewReview';
import UpdateReview from './pages/admin/UpdateReview';
// blogs
import Addblog from './pages/admin/Addblog';
import UpdateBlog from './pages/admin/UpdateBlog';
import AdminBlogs from './pages/admin/AdminBlogs';
import ViewBlog from './pages/admin/ViewBlog';

// blogs
import AddTeam from './pages/admin/AddTeam';
import UpdateTeam from './pages/admin/UpdateTeam';
import TeamsList from './pages/admin/TeamsList';
import ViewTeam from './pages/admin/ViewTeam';

import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
// import ShareholderTemplate from './pages/ShareholderTemplate';
// import Blog from './pages/Blog';
// import BlogIndex from './pages/BlogIndex';

import Categorys from './pages/admin/CategoryListPage';
import ViewCategory from './pages/admin/CategoryDetailsPage';
import UpdateCategory from './pages/admin/CategoryUpdatePage';
import AddCategory from './pages/admin/CategoryAddPage';
// Aos Animation

import "aos/dist/aos.css";
// import About from './pages/About';
// import ForContractors from './pages/ForContractors';
// import ForArchitectsDesigners from './pages/ForArchitectsDesigners';
// import LightingFacade from './pages/LightingFacade';
import AdminProjectsFeatured from './pages/admin/AdminProjectsFeatured';
// import PrivacyPolicy from './pages/PrivacyPolicy';
// import TermsOfUse from './pages/TermsOfUse';
import AdminLanguage from './pages/admin/AdminLanguage';
import AddLanguage from './pages/admin/AddLanguage';
import ViewLanguage from './pages/admin/ViewLanguage';
import UpdateLanguage from './pages/admin/UpdateLanguage';
import LanguageRoute from './components/LanguageRoute';
import HomePageBannerData from './pages/admin/HomePageBannerData';
import FacadePageBannerData from './pages/admin/FacadePageBannerData';
import ContactUS from './pages/ContactUs'
import ContractorPageBannerData from './pages/admin/ContractorPageBannerData';
import ArchitectureDesignerPageBannerData from './pages/admin/ArchitectureDesignerPageBannerData';
import Services from './pages/admin/AdminService';
import AddService from './pages/admin/AddService';
import ServiceDetails from './components/admincomponents/ServiceDetails';
import UpdateService from './pages/admin/UpdateService';
import ViewService from './pages/admin/ViewService';
import SingleService from './pages/SingleService';
import AdminProjectsCategory from './pages/admin/AdminProjectsCategory';

const Home = lazy(() => import("./pages/Home"));
const Project_index = lazy(() => import("./pages/Project_index"));
// const ContactUS = lazy(() => import("./pages/ContactUS"));
const Projects = lazy(() => import("./pages/Projects"));
const ShareholderTemplate = lazy(() => import("./pages/ShareholderTemplate"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const About = lazy(() => import("./pages/About"));
const ForContractors = lazy(() => import("./pages/ForContractors"));
const ForArchitectsDesigners = lazy(() => import("./pages/ForArchitectsDesigners"));
const LightingFacade = lazy(() => import("./pages/LightingFacade"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isAdminRoute = window.location.pathname.startsWith('/admin');

  useEffect(() => {
    const body = document.querySelector("body");
    if (isAdminRoute) {
      body.classList.add("adminPanel");
    } else {
      body.classList.remove("adminPanel");
    }

    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('token');
  };

  if (isLoading) {
    // Render nothing or a loading spinner until authentication is confirmed
    return <div>Loading...</div>;
  }

  return (
    <>
      <PrimeReactProvider>
        <Suspense fallback={<div>Loading...</div>}>

          <Routes>

            <Route path="/" element={<Home />} />
            <Route path="/project_index" element={<Project_index />} />
            <Route path="/contact-us" element={<ContactUS />} />
            <Route path="/project/:id" element={<Projects />} />
            <Route path="/shareholders" element={<ShareholderTemplate />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/blog-index/:slug" element={<BlogIndex />} />
            <Route path="/about" element={<About />} />
            <Route path="/for-contractors" element={<ForContractors />} />
            <Route path="/for-architects-and-designers" element={<ForArchitectsDesigners />} />
            <Route path="/lighting-facade" element={<LightingFacade />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />




            <Route path="/services/:id" element={<SingleService />} />

            <Route path="/:lang/services/:id" element={<LanguageRoute><SingleService /></LanguageRoute>} />

            <Route path="/:lang/" element={<LanguageRoute><Home /></LanguageRoute>} />
            <Route path="/:lang/project_index" element={<LanguageRoute><Project_index /></LanguageRoute>} />
            <Route path="/:lang/contact-us" element={<LanguageRoute><ContactUS /></LanguageRoute>} />
            <Route path="/:lang/project/:id" element={<LanguageRoute><Projects /></LanguageRoute>} />
            <Route path="/:lang/shareholders" element={<LanguageRoute><ShareholderTemplate /></LanguageRoute>} />
            <Route path="/:lang/blogs" element={<LanguageRoute><Blog /></LanguageRoute>} />
            <Route path="/:lang/blog-index/:slug" element={<LanguageRoute><BlogIndex /></LanguageRoute>} />
            <Route path="/:lang/about" element={<LanguageRoute><About /></LanguageRoute>} />
            <Route path="/:lang/for-contractors" element={<LanguageRoute><ForContractors /></LanguageRoute>} />
            <Route path="/:lang/for-architects-and-designers" element={<LanguageRoute><ForArchitectsDesigners /></LanguageRoute>} />
            <Route path="/:lang/lighting-facade" element={<LanguageRoute><LightingFacade /></LanguageRoute>} />
            <Route path="/:lang/privacy-policy" element={<LanguageRoute><PrivacyPolicy /></LanguageRoute>} />
            <Route path="/:lang/terms-of-use" element={<LanguageRoute><TermsOfUse /></LanguageRoute>} />











            {/* frontend routes */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Dashboard onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/login"
              element={
                isAuthenticated ? (
                  <Navigate to="/admin/dashboard" />
                ) : (
                  <AdminLogin onLogin={handleLogin} />
                )
              }
            />

            {/* Projects */}
            <Route
              path="/admin/projects"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminProjects onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/fetured-projects"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminProjectsFeatured onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/add-project"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AddProjects onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/project/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewProjects onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/update-project/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdateProjects onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/category-projects"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminProjectsCategory onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/services"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Services onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />


            <Route
              path="/admin/add-service"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AddService onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/service/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewService onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/update-service/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdateService onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            {/* Language */}
            <Route
              path="/admin/languages"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminLanguage onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/add-language"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AddLanguage onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/language/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewLanguage onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/update-language/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdateLanguage onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/category"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Categorys onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/category-details/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewCategory onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/category-update/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdateCategory onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/category-add"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AddCategory onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/home-page-banner"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <HomePageBannerData onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/facade-page"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <FacadePageBannerData onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/contractor"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ContractorPageBannerData onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/arch-design"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ArchitectureDesignerPageBannerData onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            {/* Portfolios */}
            <Route
              path="/admin/portfolios"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminPortfolios onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/add-portfolio"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AddPortfolio onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/portfolio/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewPortfolio onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/update-portfolio/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdatePortfolio onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            {/* Shareholders */}
            <Route
              path="/admin/shareholders"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminShareholders onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/add-shareholder"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AddShareholder onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/shareholder/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewShareholder onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/update-shareholder/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdateShareholder onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            {/* Reviews */}
            <Route
              path="/admin/add-review"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AddReviews onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/reviews"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminReviews onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/review/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewReview onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/update-review/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdateReview onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            {/* Blogs */}
            <Route
              path="/admin/blogs"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminBlogs onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/add-blog"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Addblog onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/blog/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewBlog onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/update-blog/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdateBlog onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            {/* Teams */}
            <Route
              path="/admin/teams"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <TeamsList onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/add-team"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AddTeam onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/team/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ViewTeam onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/update-team/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UpdateTeam onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Settings onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

          </Routes>
        </Suspense>
      </PrimeReactProvider>
    </>
  );
}

export default App;
